import { render, staticRenderFns } from "./SaleEditMobileEditRow.vue?vue&type=template&id=0bb4c93a"
import script from "./SaleEditMobileEditRow.vue?vue&type=script&lang=ts"
export * from "./SaleEditMobileEditRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bb4c93a')) {
      api.createRecord('0bb4c93a', component.options)
    } else {
      api.reload('0bb4c93a', component.options)
    }
    module.hot.accept("./SaleEditMobileEditRow.vue?vue&type=template&id=0bb4c93a", function () {
      api.rerender('0bb4c93a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleEditMobileEditRow.vue"
export default component.exports